export { default as Img200 } from './processed/200/InDarkness-448x252.jpg';
export { default as Img400 } from './processed/400/InDarkness-448x252.jpg';
export { default as Imgthumb } from './processed/thumb/InDarkness-448x252.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/InDarkness-448x252.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/InDarkness-448x252.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      192,
      149,
      54
    ],
    "_population": 862,
    "_hsl": [
      0.11473429951690822,
      0.5609756097560975,
      0.4823529411764706
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      214,
      152
    ],
    "_population": 366,
    "_hsl": [
      0.12301587301587301,
      0.6885245901639346,
      0.7607843137254902
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      100,
      52,
      20
    ],
    "_population": 1,
    "_hsl": [
      0.06666666666666667,
      0.6666666666666666,
      0.23529411764705882
    ]
  },
  "Muted": {
    "_rgb": [
      168,
      135,
      104
    ],
    "_population": 398,
    "_hsl": [
      0.08072916666666667,
      0.26890756302521,
      0.5333333333333333
    ]
  },
  "LightMuted": {
    "_rgb": [
      189,
      170,
      140
    ],
    "_population": 2929,
    "_hsl": [
      0.10204081632653055,
      0.2707182320441989,
      0.6450980392156863
    ]
  },
  "DarkMuted": {
    "_rgb": [
      73,
      58,
      39
    ],
    "_population": 4149,
    "_hsl": [
      0.09313725490196079,
      0.3035714285714285,
      0.2196078431372549
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/InDarkness-448x252.js